<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc-bot"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/inroduction#int">Introduction by Harry Turtledove</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">If the South Had Won the Civil War</a></p>
<p class="toc-bot"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">An Historical Inversion</span></p>
<p class="toc"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">Forge Books by MacKinlay Kantor</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2556415e